import { SignIn } from "@clerk/react";

export default function AdminSignIn() {
  return (
    <main className="min-h-[calc(100vh-5rem)] bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full flex flex-col items-center">
        <div className="text-center mb-6">
          <div className="text-xs font-bold uppercase tracking-wider text-[#1e429f]">
            TechSaathi Admin
          </div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 mt-1">
            Sign in to continue
          </h1>
          <p className="text-sm text-slate-500 mt-2">
            Only authorised admins can access the dashboard.
          </p>
        </div>
        <SignIn
          routing="path"
          path="/admin/sign-in"
          signUpUrl="/admin/sign-up"
          withSignUp
        />
      </div>
    </main>
  );
}
